import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "supplierSelect",
    "quoteRow",
    "responseDate",
    "unitPrice",
    "deliveryTime",
  ];

  connect() {
    if (this.hasResponseDateTarget) {
      this.responseDateTarget.value = new Date().toISOString().split("T")[0];
    }
  }

  openQuoteForm(event) {
    event.preventDefault();

    const itemId = event.currentTarget.dataset.itemId;
    const supplierId = event.currentTarget.dataset.supplierId;

    // Remplir le formulaire avec les données
    const form = this.formTarget;
    form.querySelector(
      '[name="supplier_quote[purchase_request_item_id]"]'
    ).value = itemId;
    form.querySelector('[name="supplier_quote[supplier_id]"]').value =
      supplierId;

    // Afficher le nom du fournisseur
    const supplierName = event.currentTarget.dataset.supplierName;
    if (this.hasSupplierSelectTarget) {
      this.supplierSelectTarget.textContent = supplierName;
    }

    // Afficher le formulaire
    form.classList.remove("hidden");
  }

  closeQuoteForm(event) {
    event.preventDefault();
    this.formTarget.classList.add("hidden");
    this.resetForm();
  }

  resetForm() {
    this.formTarget.reset();
  }
}
